<template>
  <PhoneRequests />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PhoneRequests from "../../../components/Customers/Demandes/PhoneRequests.vue";

export default defineComponent({
  name: "PhoneRequestsPage",
  components: { PhoneRequests },
});
</script>
